import React from 'react'
import { FormattedMessage } from 'react-intl'

import { experience, subject, copy, oeReview } from '../../../../utils/messages'

const ReviewProcessInfo = () => (
  <div className="not-assigned-nor-author-nor-reviewer">
    <div className="container">
      <p className="guidance">
        <FormattedMessage
          id={'InternalReview.WhenThisQuest'}
          defaultMessage="When this quest is ready for review, it will be evaluated by reviewers within its organization, using three types of criteria:"
        />
      </p>
      <div className="review-type-bold">
        {experience}
        <div className="vertical-divider" />
        {subject}
        <div className="vertical-divider" />
        {copy}
      </div>
    </div>

    <div className="arrow" />

    <div className="container">
      <p className="guidance">
        <FormattedMessage
          id={'InternalReview.Then,TheQuest'}
          defaultMessage={
            'Then, the quest will be reviewed by Publication Reviewers to ensure it meets final quality standards.'
          }
        />
      </p>
      <div className="review-type-bold oe">{oeReview}</div>
    </div>

    <div className="arrow" />

    <div className="container">
      <p className="guidance">
        <FormattedMessage
          id={'InternalReview.WithQualityReview'}
          defaultMessage={
            'With Publication Review approval, the quest will be published in the Quest! app and will be available to learners and mentors.'
          }
        />
      </p>
      <div className="tablet img" />
      <div className="desktop img" />
    </div>
  </div>
)

export default ReviewProcessInfo



// WEBPACK FOOTER //
// ./src/components/quest/review/internalreview/ReviewProcessInfo.js